import { Link, Stack, TextField, Typography } from "@mui/material";
import { MRT_Column, MRT_ColumnDef } from "material-react-table";
import { QaPendingOrder, qaChecklistHref } from "./types";

function UpdatedDateFilter({ column }: { column: MRT_Column<QaPendingOrder> }) {
  const [from = "", to = ""] = (column.getFilterValue() || []) as string[];
  return <Stack spacing={1} sx={{ py: 1 }}>
    <TextField type="date" size="small" label="From" value={from} InputLabelProps={{ shrink: true }}
      onChange={(event) => column.setFilterValue([event.target.value, to])} />
    <TextField type="date" size="small" label="To" value={to} InputLabelProps={{ shrink: true }}
      onChange={(event) => column.setFilterValue([from, event.target.value])} />
  </Stack>;
}

export const qaReviewColumns: MRT_ColumnDef<QaPendingOrder>[] = [
  {
    accessorKey: "orderNumber", header: "Order", size: 160,
    Cell: ({ row }) => <Link href={qaChecklistHref(row.original.orderNumber)} target="_blank" rel="noopener">
      {row.original.orderNumber}
    </Link>
  },
  {
    id: "closer", accessorFn: (order) => order.closerName || "Unassigned", header: "Closer", size: 200
  },
  {
    accessorKey: "noteCount", header: "QA findings", size: 150,
    filterVariant: "range", filterFn: "betweenInclusive"
  },
  {
    id: "latestPolicyNote", accessorFn: (order) => order.latestPolicyNote?.text || "",
    header: "Latest Policy Issues note", size: 360,
    Cell: ({ row }) => {
      const note = row.original.latestPolicyNote;
      if (!note) return <Typography variant="body2" color="text.secondary">No policy note</Typography>;
      return <Stack spacing={0.5}>
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{note.text}</Typography>
        <Typography variant="caption" color="text.secondary">
          {note.createdBy} · {new Date(note.createdAt).toLocaleString()}
        </Typography>
        <Link href={`/policy-issues?orderNumber=${encodeURIComponent(row.original.orderNumber)}`} target="_blank" rel="noopener" variant="caption">
          View Policy Issues
        </Link>
      </Stack>;
    }
  },
  {
    id: "updatedAt", accessorFn: (order) => new Date(order.updatedAt), header: "Last QA update", size: 210,
    sortingFn: "datetime",
    Filter: ({ column }) => <UpdatedDateFilter column={column} />,
    filterFn: (row, id, value: string[]) => {
      const [from, to] = value || [];
      const updated = row.getValue<Date>(id).getTime();
      const start = from ? new Date(`${from}T00:00:00`).getTime() : -Infinity;
      const end = to ? new Date(`${to}T23:59:59.999`).getTime() : Infinity;
      return updated >= start && updated <= end;
    },
    Cell: ({ row }) => new Date(row.original.updatedAt).toLocaleString()
  }
];
